export enum BillingStatusEnum {
    All = 0,
    Overdue = 1,
    Open = 2,
    Paid = 3,
    Canceled = 4,
}
